import { motion } from 'framer-motion';

interface TimelineTabProps {
  activeTab: 'global' | 'favorite' | 'unlocked';
  onTabChange: (tab: 'global' | 'favorite' | 'unlocked') => void;
  sortOrder: 'newest' | 'popular';
  onSortChange: (sort: 'newest' | 'popular') => void;
}

export function TimelineTab({ activeTab, onTabChange, sortOrder, onSortChange }: TimelineTabProps) {
  const tabs = [
    { id: 'global' as const, label: 'GLOBAL', icon: 'ri-global-line' },
    { id: 'favorite' as const, label: 'FAVORITE', icon: 'ri-heart-line' },
    { id: 'unlocked' as const, label: 'UNLOCKED', icon: 'ri-lock-unlock-line' },
  ];

  const sortOptions = [
    { id: 'newest' as const, label: '新着順', icon: 'ri-time-line' },
    { id: 'popular' as const, label: '人気順', icon: 'ri-fire-line' },
  ];

  return (
    <div className="flex items-center justify-between gap-3">
      {/* タブ */}
      <div className="flex items-center gap-2">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const isFav = tab.id === 'favorite';
          return (
            <motion.button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              whileHover={{ backgroundColor: isActive ? undefined : 'rgba(63,63,70,0.5)' }}
              whileTap={{ scale: 0.98 }}
              className={`relative px-4 py-1.5 rounded-full font-medium text-xs transition-all whitespace-nowrap cursor-pointer ${
                isActive
                  ? isFav
                    ? 'bg-zinc-800 text-brand-secondary border border-zinc-700'
                    : 'bg-zinc-800 text-brand-primary border border-zinc-700'
                  : 'bg-zinc-800/40 text-zinc-400 border border-zinc-700/50'
              }`}
            >
              <div className="flex items-center gap-1.5">
                <i className={`${tab.icon} text-base`} />
                <span>{tab.label}</span>
              </div>
            </motion.button>
          );
        })}
      </div>

      {/* ソート切り替え */}
      <div
        className="flex items-center gap-0.5 p-0.5 rounded-full bg-zinc-800/40 border border-zinc-700/50"
      >
        {sortOptions.map((opt) => {
          const isActive = sortOrder === opt.id;
          return (
            <motion.button
              key={opt.id}
              onClick={() => onSortChange(opt.id)}
              whileHover={{ backgroundColor: isActive ? undefined : 'rgba(63,63,70,0.5)' }}
              whileTap={{ scale: 0.98 }}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-bold tracking-wider whitespace-nowrap cursor-pointer transition-all duration-200"
              style={
                isActive
                  ? {
                      background:
                        opt.id === 'popular'
                          ? 'rgba(251,146,60,0.2)'
                          : 'rgba(34,211,238,0.2)',
                      color: opt.id === 'popular' ? '#fb923c' : '#22d3ee',
                    }
                  : {
                      background: 'transparent',
                      color: 'rgba(255,255,255,0.3)',
                    }
              }
            >
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className={`${opt.icon} text-xs`} />
              </span>
              <span>{opt.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}